import { FIELDS_TO_TRANSFORM } from "services/sosInventoryService/report/schema";
import { transformFields } from "services/utility/afterGet";

export function afterGet(record, type) {
  const newRecord = transformFields(record, FIELDS_TO_TRANSFORM[type]);
  return newRecord;
}
